import { HiddenA11yText, StyledExternalIcon } from 'app/components/Link/Link.styles';
import React from 'react';
import { BUTTON_TYPE, BUTTON_THEME } from '../PlayButton/PlayButton';
import {
    Button,
    Heading,
    StyledSurvey,
    StyledSurveyImage,
    StyledSurveyTextContainer,
    CloseButton,
    Text,
    FixedContainer,
} from './StyledSurvey.styles';

type Props = {
    survey: any; // Add Contento type here when its available
    onTakeSurvey: (id: number) => void;
    onCloseSurvey: (id: number) => void;
    buttonText: string;
};

const Survey = ({ survey, onTakeSurvey, onCloseSurvey, buttonText }: Props) => {
    return (
        <FixedContainer>
            <StyledSurvey>
                <StyledSurveyTextContainer>
                    <Heading>{survey.heading}</Heading>
                    <Text>{survey.subHeading}</Text>

                    <Button
                        href={survey.surveyUrl}
                        buttonType={BUTTON_TYPE.ANCHOR}
                        onClick={() => {
                            onTakeSurvey(survey.id);
                        }}
                        theme={BUTTON_THEME.LIGHT}
                        target="_blank"
                    >
                        <StyledExternalIcon aria-hidden="true" />
                        {buttonText}
                        <HiddenA11yText>, öppnar annan webbplats</HiddenA11yText>
                    </Button>
                </StyledSurveyTextContainer>
                <StyledSurveyImage>
                    <CloseButton
                        type="button"
                        onClick={() => {
                            onCloseSurvey(survey.id);
                        }}
                    >
                        <HiddenA11yText>Stäng enkät</HiddenA11yText>
                    </CloseButton>
                </StyledSurveyImage>
            </StyledSurvey>
        </FixedContainer>
    );
};

export default Survey;
